module.exports = __webpack_public_path__ + "img/helpSteps3-1-2.9c5000b2.png";